<template>
  <transition name="fade-slide">
    <div v-if="visible" class="agree-overlay" @click.self="closeAgreement">
      <div class="agree-popup" role="dialog" :aria-labelledby="title">
        <button type="button" class="agree-close" aria-label="关闭" @click="closeAgreement">
          <AppIcon name="close" size="sm" aria-label="" />
        </button>
        <h2 class="agree-title">{{ title || '协议' }}</h2>
        <div v-if="loading" class="agree-hint">加载中...</div>
        <div v-else-if="errorMessage" class="agree-error">{{ errorMessage }}</div>
        <div v-else class="agree-content" v-html="contentHtml"></div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import AppIcon from '@/shared/components/AppIcon.vue'
import { useAgreement } from '@/features/comic/composables/useAgreement'

const { visible, loading, errorMessage, title, contentHtml, closeAgreement } = useAgreement()
</script>

<style scoped>
.agree-overlay {
  position: fixed;
  inset: 0;
  z-index: 1130;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  padding: var(--spacing-base);
}

.agree-popup {
  position: relative;
  width: 100%;
  max-width: 32rem;
  max-height: 80vh;
  overflow: auto;
  background: var(--color-bg-base, #fff);
  border-radius: var(--radius-base);
  padding: var(--spacing-lg);
  box-shadow: var(--shadow-lg);
}

.agree-close {
  position: absolute;
  top: var(--spacing-sm);
  right: var(--spacing-sm);
  border: none;
  background: none;
  font-size: var(--font-size-large);
  color: var(--color-text-secondary);
  cursor: pointer;
}

.agree-title {
  margin: 0 0 var(--spacing-base);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
  color: var(--color-text-primary);
}

.agree-hint,
.agree-error,
.agree-content {
  font-size: var(--font-size-base);
  line-height: var(--line-height-relaxed);
  color: var(--color-text-regular);
}

.agree-error {
  color: var(--color-danger, #c0392b);
}

.agree-content :deep(p) {
  margin: 0 0 var(--spacing-sm);
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity var(--transition-base, 0.2s);
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
}
</style>
